export enum AuthoringColumnProduct {
  Carports = 'carports',
  Shared = 'shared',
  Sheds = 'sheds',
}
